module.exports = __webpack_public_path__ + "static/media/3.a0b52d4f.gif";